module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_01_6NX26_1SF_H2U.f1242c79.jpg";